
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductBillingItemsGrid1 extends Serenity.EntityGrid<ProductBillingItemsRow, any> {
        protected getColumnsKey() { return 'Products.ProductBillingItems'; }
        protected getDialogType() { return ProductBillingItemsDialog; }
        protected getIdProperty() { return ProductBillingItemsRow.idProperty; }
        protected getInsertPermission() { return ProductBillingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductBillingItemsRow.localTextPrefix; }
        protected getService() { return ProductBillingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {
            // debugger;
             this.editItem({ ProductId: this.ProductId });
          //  this.editItem({ ProductId: this.ProductId, IsTab: true });


        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.ProductId != null;
        }

        private _ProductId: number;

        get ProductId() {
            return this._ProductId;
        }

        set ProductId(value: number) {
            //debugger;
            if (this._ProductId != value) {
                this._ProductId = value;
                this.setEquality(ProductBillingItemsRow.Fields.ProductId, value);
                this.refresh();
            }
        }
    }
}